import React from "react"
import labels from "../i18n/hr"
import Contact from "./_contact"

export default function ContactHR() {
  return <Contact labels={labels} />
}
